import React from 'react';
import {OutlineErrorIcon} from 'common/icons';
import {Button} from 'common/button';
import {Panel} from 'pages/user/components';
import {useSignUpState} from 'state/sign-up';
import {useNavigate} from 'react-router';
import {RoutesSettings} from 'config/routes';

import styles from './register-error-message.module.scss';

export const RegisterErrorMessage = () => {
    const {rut} = useSignUpState();
    const navigation = useNavigate();

    return (
        <Panel className={styles.container}>
            <OutlineErrorIcon size={80}/>
            <h2>Usuario no registrado</h2>
            <span>Ya existe un usuario creado para el RUT: {rut}. Contacte con el administrador para recuperar su cuenta.</span>
            <a href="mailto:soporte-idauto@dox.cl">soporte-idauto@dox.cl</a>
            <Button label="Aceptar" onClick={() => navigation(RoutesSettings.signIn, {replace: true})}/>
        </Panel>
    );
};
